export default __webpack_public_path__ + "static/media/arrowTracking.6b03616b.svg";